module.exports = __webpack_public_path__ + "static/media/DCC-Logo.c6063753.svg";